export enum SoilAnalysisFileStatus {
  Success = 'SUCCESS',
  Error = 'ERROR',
  Processing = 'PROCESSING'
}
